import * as filterActions from '../actions/filter.actions';
import { Filter, FilterType } from '../models/Filter';

export function reducer(filterState: Filter[] = [], action: filterActions.FilterAction): Filter[] {

  switch (action.type) {

    case filterActions.ADD_FILTER: {
      if (action.payload.type === FilterType.PRICE) {
        const availablePriceFilter = filterState.find(filter => filter.type === FilterType.PRICE);

        if (availablePriceFilter) {
          const otherFilters: Filter[] = filterState.filter(filter => filter.type !== FilterType.PRICE);
          return [...otherFilters, action.payload];
        }
        return [...filterState, action.payload];
      } else if (action.payload.type === FilterType.GEO) {
        const availableGeoFilter = filterState.find(filter => filter.type === FilterType.GEO);
        if (availableGeoFilter) {
          const otherFilters: Filter[] = filterState.filter(filter => filter.type !== FilterType.GEO);
          return [...otherFilters, action.payload];
        }
        return [...filterState, action.payload];
      }
      //else if (action.payload.type === FilterType.TAG) {
      if (!filterState.find(f => ' ' + f.value === ' ' + action.payload.value)) {
        if (filterState.findIndex(f => f.type === action.payload.type) > -1) {
          filterState.splice(filterState.findIndex(f => f.type === action.payload.type), 1, action.payload);
        } else {
          return [...filterState, action.payload];
        }
      }
      return filterState;
      // }

      //filterState.find(f => ' ' + f.value === ' ' + action.payload.value) ? filterState : [...filterState, action.payload];
      // if (!filterState.find(f => ' ' + f.value === ' ' + action.payload.value)) {
      //   filterState.splice(filterState.findIndex(f => f.type === action.payload.type), 1, action.payload);
      // }
      // return filterState;
    }

    case filterActions.REMOVE_FILTER: {
      return filterState.filter((filter) => action.payload.value !== filter.value);
    }

    default: {
      return filterState;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/reducers/filter.reducer.ts